import { render, staticRenderFns } from "./ResolutionDesktop.vue?vue&type=template&id=c85f9fbc&scoped=true&"
import script from "./ResolutionDesktop.vue?vue&type=script&lang=ts&"
export * from "./ResolutionDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./ResolutionDesktop.vue?vue&type=style&index=0&id=c85f9fbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85f9fbc",
  null
  
)

export default component.exports